import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["shareButton", "item", "parentPlaylist", "parentTrack", "onShare"];
import { useSocialShareList } from '../components/SocialShareList';
import { MultiLevelDropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialShareDropdown = _ref => {
  let {
      shareButton = /*#__PURE__*/_jsx(Button, {
        size: "sm",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.common.share"
        })
      }),
      item,
      parentPlaylist,
      parentTrack,
      onShare
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const list = useSocialShareList({
    item,
    parentPlaylist,
    parentTrack,
    onShare
  });
  return /*#__PURE__*/_jsx(MultiLevelDropdown, Object.assign({
    arrowSize: "small",
    buttonText: shareButton,
    buttonUse: "unstyled",
    caretRenderer: null,
    options: list,
    placement: "right bottom"
  }, props));
};
export default SocialShareDropdown;